import { SuretyAccountId, WorkInProgressStatementId } from "@inrev/common";
import { useGlobalErrorMessageModal } from "@portal/providers/GlobalErrorHandlingProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import { wipQueryKey } from "../../account/account.keys";

export const useAdminDeleteWorkInProgressStatement = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { _delete } = useRequest();
	const { triggerErrorModal } = useGlobalErrorMessageModal();

	const mutation = useMutation({
		mutationKey: ["deleteWipStatement"],
		mutationFn: async (statementId: WorkInProgressStatementId) => {
			await _delete(`/v2/admin/surety/wip-statement/${statementId}`, undefined, "none");
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: wipQueryKey(accountId),
			});
			await queryClient.refetchQueries({
				queryKey: wipQueryKey(accountId),
			});
		},
		onError: (error: Error, _statementId, previousData) => {
			if (previousData) {
				queryClient.setQueryData(wipQueryKey(accountId), previousData);
			}
			logError(error);
			triggerErrorModal(error);
		},
	});

	return {
		deleteWipStatement: mutation.mutate,
		deleteWipStatementIsLoading: mutation.isPending,
		deleteWipStatementSuccess: mutation.isSuccess,
	};
};
